import React from 'react';
import {Text} from 'react-native';
import {CertificateInfo} from '../../../../shared/models/api/eCertificatesResponsePayload';
import {Table} from '../../../../shared/components/table';
import {Column} from '../../../../shared/components/table/model';
import {formatDate} from '../../../../shared/utils/formatDate';
import {useCertificateTableStyles} from './CertificateTable.style';

interface CertificateTableProps {
  certificate?: CertificateInfo | null;
}

export function CertificateTable({certificate}: CertificateTableProps) {
  const styles = useCertificateTableStyles();

  const columns: Column<CertificateInfo>[] = [
    {
      title: 'Дата начала',
      field: 'startDate',
      render: (row) => {
        return <Text style={styles.colText}>{formatDate(row.startDate)}</Text>;
      },
      headStyles: {
        colHeadStyle: styles.cellStyle,
      },
      styles: {
        colBodyStyle: styles.cellStyle,
      },
    },
    {
      title: 'Дата окончания',
      field: 'endDate',
      render: (row) => {
        return <Text style={styles.colText}>{formatDate(row.endDate)}</Text>;
      },
      headStyles: {
        colHeadStyle: styles.cellStyle,
      },
      styles: {
        colBodyStyle: styles.cellStyle,
      },
    },
    {
      title: 'Статус',
      field: 'statusName',
      headStyles: {
        colHeadStyle: styles.cellStyle,
      },
      styles: {
        colBodyTextStyle: styles.colTextPrimary,
        colBodyStyle: styles.cellStyle,
      },
    },
    // {
    //   title: 'Остаток ТРУ',
    //   field: 'quantity',
    //   headStyles: {
    //     colHeadStyle: styles.cellStyle,
    //   },
    //   styles: {
    //     colBodyTextStyle: styles.colText,
    //     colBodyStyle: styles.cellStyle,
    //   },
    // },
  ];

  return <Table data={certificate ? [certificate] : null} columns={columns} isBordered={false} />;
}
